import * as XLSX from "xlsx";
import { ClockifyTimeEntry } from "../clockifyTimeEntries/ClockifyTimeEntry";
import TimeFormatter from "../extensions/TimeFormatter";

interface TypeOfWorkSummary {
  typeOfWork: string;
  totalHours: number;
}

export class TypeOfWorkSummaryExcelExporter {
  exportToExcel(timeEntries: ClockifyTimeEntry[], fileName: string) {
    const fileNameWithExtension = fileName.endsWith(".xlsx")
      ? fileName
      : `${fileName}.xlsx`;

    const timeFormatter = new TimeFormatter();

    const aggregateTypeOfWorkData = (): TypeOfWorkSummary[] => {
      const typeOfWorkMap = new Map<string, number>();

      timeEntries.forEach((entry) => {
        const typeOfWork = entry.typeOfWork || "N/A";
        const currentTotal = typeOfWorkMap.get(typeOfWork) || 0;
        typeOfWorkMap.set(typeOfWork, currentTotal + entry.timeSpentInHours);
      });

      return Array.from(typeOfWorkMap.entries())
        .map(([typeOfWork, totalHours]) => ({
          typeOfWork,
          totalHours,
        }))
        .sort((a, b) => {
          if (a.typeOfWork === "N/A" && b.typeOfWork !== "N/A") return 1;
          if (a.typeOfWork !== "N/A" && b.typeOfWork === "N/A") return -1;
          return b.totalHours - a.totalHours;
        });
    };

    const typeOfWorkData = aggregateTypeOfWorkData();

    const headers = ["Type of Work", "Total Hours", "Decimal Total Hours"];

    const data = typeOfWorkData.map((item) => ({
      "Type of Work": item.typeOfWork,
      "Total Hours": timeFormatter.toHoursAndMinutes(item.totalHours),
      "Decimal Total Hours": Number(item.totalHours.toFixed(2)),
    }));

    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });

    const columnWidths = [
      { wch: 25 }, // Type of Work
      { wch: 15 }, // Total Hours
      { wch: 20 }, // Decimal Total Hours
    ];

    worksheet["!cols"] = columnWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TypeOfWorkSummary");
    XLSX.writeFile(workbook, fileNameWithExtension);
  }
}
